export const calendarObjectsFields = {
  SOMEETING: {
    setDataTable: "SOACTION",
    tableData: { text: "SOMEETING_TRDR_GENTRDR_NAME", fromDate: "SOMEETING_FROMDATE", toDate: "SOMEETING_FINALDATE" },
    fromDate: "SOMEETING.FROMDATE",
    toDate: "SOMEETING.FINALDATE",
  },
};
